import React, {useContext, useMemo} from 'react';
import {Link, useLocation, useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import styled from 'styled-components';
import configuration from 'configuration';
import LangButton from './LangButton';
import {AppContext} from 'AppContext';

const NavBar = () => {
  const {customNavElement} = useContext(AppContext);
  const {t} = useTranslation();
  const location = useLocation();

  const isHomePage = useMemo(() => location.pathname === '/', [location]);
  const langTitle = useMemo(() => configuration.path2langKey(location.pathname, 'T'), [location]);
  const multiLangSupport = useMemo(() => configuration.languages.length > 1, []);

  return (
    <Container>
      {!isHomePage && (
        <>
          <BackButton />
          <Spacer />
          <HomeButton />
          <Spacer />
        </>
      )}
      <Title className="no-select">{t(langTitle).replaceAll('\\n', ' | ')}</Title>
      {customNavElement && (
        <>
          <Spacer />
          {customNavElement}
        </>
      )}
      {isHomePage && (
        <>
          <Spacer />
          <NavButton to="/impressum">{t('impressum.T')}</NavButton>
        </>
      )}
      {multiLangSupport && (
        <>
          <Spacer />
          <LangButton />
        </>
      )}
    </Container>
  );
};
export default NavBar;

const NavButton = styled(Link)`
  display: block;
  box-sizing: border-box;
  height: var(--nav-bar-height);
  line-height: calc(var(--nav-bar-height) - 2 * var(--margin));
  padding: var(--margin);
  font-size: 15px;
  font-weight: 700;
  color: var(--color-text);
  text-decoration-line: none;

  &:visited {
    color: var(--color-text);
  }

  &:active,
  body:not(.philo-screen) &:hover {
    color: var(--color-blue);
  }
`;

const BackButton = () => {
  const navigate = useNavigate();
  return (
    <svg
      className="nav-button"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      onClick={() => navigate(-1)}>
      <polyline className="icon" points="179,18 72,126 184,238" />
    </svg>
  );
};

const HomeButton = () => {
  const navigate = useNavigate();
  return (
    <svg
      className="nav-button"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
      onClick={() => navigate('/')}>
      <path
        className="icon"
        d="m128 5-3 1L7 98c-2 2-3 5-1 8 2 2 5 2 7 0l7-5v135c0 2 3 5 6 5h71v-93h62v93h71c3 0 6-3 6-5V101l7 5 3 2 4-2c2-3 1-6-1-8L131 6a5 5 0 0 0-3-1zm51 21v5l31 24V26z"
      />
    </svg>
  );
};

const Container = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: var(--nav-bar-height);
  border-bottom: 1px solid var(--color-border);
`;

const Spacer = styled.div`
  margin 1px;
  width: 1px;
  height: calc(var(--nav-bar-height) / 2);
  background: var(--color-border);
`;

const Title = styled.div`
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-left: 10px;
  margin-right: 10px;
  text-align: center;
  white-space: nowrap;
  font-weight: 500;
`;
